/*****************************************************************************
*********************   CUSTOM JS OUTSIDE OF THEME    ************************
*****************************************************************************/

document.addEventListener('DOMContentLoaded', () => {
  // For SEO purposes, every img title should be an img alt as well
  if (document.getElementById('product')) {
    document.querySelectorAll('img').forEach(img => {
      if (!img.title && img.alt) img.title = img.alt;
    });
  }
  // open external links in new tabs
  document.querySelectorAll('a[href]').forEach(a =>
    {
    if (location.hostname == new URL(a.href).hostname)
        return;
    a.target = "_blank";
  });
  // button to close the megamenu
  document.querySelectorAll(".megamenu-close-btn").forEach(function(btn) {
    btn.onclick = function() {
      document.querySelectorAll(".site-nav__details").forEach(function(el) {
        el.removeAttribute("open");
      });
    };
  });
});

// MAKE CUSTOM: product main image prev/next arrows
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product__main-arrow').forEach(function(arrow) {
    arrow.addEventListener('click', function() {
      const isPrev = this.classList.contains('product__main-arrow--prev');
      const container = this.closest('.product__main-photos');
      const slideshow = container.querySelector('.product-slideshow');
      const slides = Array.from(slideshow.querySelectorAll('.product-main-slide'));
      const currentIndex = slides.findIndex(s => s.classList.contains('is-selected'));
      const total = slides.length;

      const targetIndex = isPrev
        ? (currentIndex - 1 + total) % total
        : (currentIndex + 1) % total;

      // Use the theme's thumb click to navigate
      const thumbs = document.querySelectorAll('[data-product-thumb]');
      if (thumbs[targetIndex]) {
        thumbs[targetIndex].click();
      }
    });
  });
});